"use client";

import React, { useEffect, useState } from "react";
import styles from "../UI/UI.module.css";
import { FontIcon } from "@/app/_components";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {RedeemRecordInfo} from "@/Core/Redeem/redeemEntity";
import {RedeemManager} from "@/Core/Redeem/RedeemManager";
import BigTips from "@/Master/BigTips";
import {DriveUtil} from "@/Master/DriveUtil";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";

interface RedeemRecordReviewDialogProps extends SDialogProps {
    /** 额外参数 */
    // 可根据需要添加其他 Props，例如：errorMessage
    recordInfo:RedeemRecordInfo,
    from:number,
}


export const RedeemRecordReviewDialogFC: React.FC<RedeemRecordReviewDialogProps> = (props) => {
    const {fcKey, onClose, from, recordInfo} = props;
    const { closeDialog } = useDialogMethods(fcKey);
    // ========== 模拟生命周期（类似 class 的 initData / onInit / onEnter） ==========
    // 用一个内部 state 控制对话框是否还可见
    const [isOpen, setIsOpen] = useState(true);

    useEffect(() => {
        return () => {
        };
    }, [props]);

    // ========== 按钮点击逻辑 ==========

    const onCloseDialog = () => {
        closeDialog();
        onClose?.();
    }

    const onConfirmClick = () => {
        showForceLoading()
        RedeemManager.Instance.CancelRedeem(recordInfo.id, finish => {
            BigTips.showMsg(finish ? 'Cancel successfully.' : 'Cancel Failed.');
            if (finish){
                onCloseDialog();
            }
            hideForceLoading();
        })
    };

    // ========== 渲染 UI ==========
    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Center"
            title="REDEMPTION UNDER REVIEW"
            onClose={onClose}
            buttons={[
                { label: "Confirm", onClick: onConfirmClick, style: "blueBtn" },
            ]}
        >
            <div className={styles.dialogContent}>
                <p>
                    By clicking Confirm, the redemption amount of <span
                    className={'sc-color'}>{DriveUtil.ToDollarString(recordInfo.dollar)}</span> will be refunded to your game Sweepstakes Coins
                    Balance immediately and the redemption order will be canceled.
                </p>
            </div>
        </SDialogFC>
    );
};
